<img [class.placeholder]="!url" [alt]="alt" [src]="url" [style.width]="width" [style.height]="height" />
